import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { WalletService } from '../../services/wallet.service';
import { ConnectWalletComponent } from '../dialogs/connect-wallet/connect-wallet.component';
import {
    MatDialog, MatDialogRef
} from '@angular/material/dialog';
import AirdropTask from '../../models/AirdropTask';

@Component({
    selector: 'app-airdrop-connect-wallet',
    templateUrl: './airdrop-connect-wallet.component.html',
    styleUrls: [ './airdrop-connect-wallet.component.scss' ]
})
export class AirdropConnectWalletComponent implements OnInit {
    @Input() task = new AirdropTask();

    constructor(public httpService: HttpService,
        private dialog: MatDialog,
        public walletService: WalletService,
        private connectWalletDialogRef: MatDialogRef<ConnectWalletComponent>
    ) {
        this.window = getWindow();
    }
    
    window: Window;

    ngOnInit(): void {
        this.attachSocketEvents();
    }

    attachSocketEvents() {
        
    }
    
    connectWallet() {
        this.connectWalletDialogRef = this.dialog.open(ConnectWalletComponent, {
            width: '550px',
            height: 'auto',
            data: {}
        });

        this.connectWalletDialogRef.afterClosed().subscribe((status: string) => {
            console.log('connectWallet afterClosed', status);

            this.window.location.reload();
        });
    }
}
